module.exports = __webpack_public_path__ + "static/media/externalization.f7449697.svg";